export const useIsUserInRole = () => {
    const userInfo = useStateUserInfo();

    return function (role: Role | Role[]) {
        return Array.isArray(role)
            ? role.some((r) => userInfo.value.Roles.includes(r))
            : userInfo.value.Roles.includes(role);
    };
};
